/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { GbcarApiConfiguration as __Configuration } from '../gbcar-api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { GetProductOrdersResponse } from '../models/get-product-orders-response';
import { PageableRequest } from '../models/pageable-request';
import { OrderStatusDto } from '../models/order-status-dto';
@Injectable({
  providedIn: 'root',
})
class ProductOrderService extends __BaseService {
  static readonly postApiProductOrderListPath = '/api/ProductOrder/List';
  static readonly postApiProductOrderSetStatusPath = '/api/ProductOrder/SetStatus';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param body undefined
   * @return Success
   */
  postApiProductOrderListResponse(body?: PageableRequest): __Observable<__StrictHttpResponse<GetProductOrdersResponse>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = body;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/ProductOrder/List`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<GetProductOrdersResponse>;
      })
    );
  }
  /**
   * @param body undefined
   * @return Success
   */
  postApiProductOrderList(body?: PageableRequest): __Observable<GetProductOrdersResponse> {
    return this.postApiProductOrderListResponse(body).pipe(
      __map(_r => _r.body as GetProductOrdersResponse)
    );
  }

  /**
   * @param body undefined
   * @return Success
   */
  postApiProductOrderSetStatusResponse(body?: OrderStatusDto): __Observable<__StrictHttpResponse<OrderStatusDto>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = body;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/ProductOrder/SetStatus`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<OrderStatusDto>;
      })
    );
  }
  /**
   * @param body undefined
   * @return Success
   */
  postApiProductOrderSetStatus(body?: OrderStatusDto): __Observable<OrderStatusDto> {
    return this.postApiProductOrderSetStatusResponse(body).pipe(
      __map(_r => _r.body as OrderStatusDto)
    );
  }
}

module ProductOrderService {
}

export { ProductOrderService }
